export const fromStyleLocals = (locals: any) => (...names: string[]) =>
  names.map(n => `${n} ${locals[n] || ""}`).join(" ");
